export function canAccessWithProfile(profile = {}) {
  return profile.activo === true;
}
